import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c(VAppBar,{attrs:{"dark":"","app":"","color":"primary"}},[_c('a',{staticClass:"ml-2 mt-2",attrs:{"href":"https://lp.proxpect.com.br/fornecedores/","target":"_blank","rel":"noopener noreferrer"}},[_c('img',{staticClass:"header-logo",attrs:{"src":require("../../assets/logo-branca.png"),"alt":"Logo da Proxpect"}})]),_c(VSpacer)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }